import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Dimmer } from "../components/spinner";
import useTable from "../components/useTable";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import { Mensaje } from "../components/mensajes";
import axios from "axios";
import useTableScroll from "../components/useTableScroll.js";

const CatalogoInmuebles = (props) => {
  const op = require("../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));

  const btnCancela = useRef();
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [values, setValues] = useState({});
  const [activo, setActivo] = useState(true);
  const [itemSelect, setItemSelect] = useState(-1);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const headCells = [
    { label: "CÓDIGO", textAlign: "center" },
    { label: "NOMBRE", textAlign: "center" },
    { label: "DIRECCIÓN", textAlign: "center" },
  ];

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTableScroll(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.idinmuebles.includes(target.value) ||
              x.descripcion
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              x.direccion.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  const SeleccionarRegistros = () => {
    setActivate(true);

    let campos =
      "idinmuebles, estado, municipio, ciudad, trim(descripcion) as descripcion, trim(direccion) as direccion";
    let nomtab = "inmuebles";
    let orden = "idinmuebles";

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setActivate(false);
          var inmu = [];
          for (let i = 0; i < response.data.length; i++) {
            inmu.push({
              idinmuebles: response.data[i].idinmuebles,
              descripcion: response.data[i].descripcion,
              estado: response.data[i].estado,
              municipio: response.data[i].municipio,
              ciudad: response.data[i].ciudad,
              direccion: response.data[i].direccion,
            });
          }
          setRecords(inmu);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const blanquear = () => {
    setActivate(false);
    setRecords([]);
    setItemSelect("");
    setFilterFn({
      fn: (items) => {
        return items;
      },
    });
    setActivo(true);
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancelaInmu();
  };

  const seleccionarAgentes = () => {
    blanquear();
    props.onHideAceptaInmu(
      values.idinmuebles,
      values.descripcion,
      values.estado,
      values.municipio,
      values.ciudad,
      values.direccion
    );
    props.onHideCancelaInmu();
  };

  const seleccionarFila = (index) => (e) => {
    e.preventDefault();
    setActivo(false);
    setItemSelect(index);
    setValues({
      idinmuebles: recordsAfterPagingAndSorting()[index].idinmuebles,
      descripcion: recordsAfterPagingAndSorting()[index].descripcion,
      estado: recordsAfterPagingAndSorting()[index].estado,
      municipio: recordsAfterPagingAndSorting()[index].municipio,
      ciudad: recordsAfterPagingAndSorting()[index].ciudad,
      direccion: recordsAfterPagingAndSorting()[index].direccion,
    });
  };

  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      size="lg"
      backdrop="static"
      keyboard={false}
      onShow={() => {
        SeleccionarRegistros();
      }}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <div className="fw-bold text-light">
          <h3 className="text-capitalize">Lista de Inmuebles</h3>
        </div>
        <button
          ref={btnCancela}
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="row col-md-12" style={{ marginBottom: "2px" }}>
          <div className="input-group col-md-4 input-group-sm mb-3">
            <input
              type="text"
              onChange={handleSearch}
              className="form-control"
            />
            <button className="btn btn-info" style={{ pointerEvents: "none" }}>
              <i className="fa fa-search"></i>
            </button>
          </div>
        </div>
        <div className="col-md-12" style={{ margin: "auto" }}>
          <TblContainer>
            <TblHead />

            <TableBody>
              {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <TableRow
                    key={index}
                    style={{
                      padding: "0",
                      cursor: "pointer",
                      background:
                        itemSelect === index ? "lightskyblue" : "white",
                    }}
                    onClick={seleccionarFila(index)}
                  >
                    <TableCell className="py-2 text-center">
                      {item.idinmuebles}
                    </TableCell>
                    <TableCell className="py-2 text-center">
                      {item.descripcion}
                    </TableCell>
                    <TableCell className="py-2 text-center">
                      {item.direccion}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </TblContainer>
          <TblPagination />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-sm btn-success rounded-pill"
          disabled={activo}
          style={{ margin: "5px" }}
          onClick={seleccionarAgentes}
        >
          <i className="fas fa-check-circle"> Aceptar</i>{" "}
        </button>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-sm btn-danger rounded-pill"
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
      <Dimmer active={activate} />
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
    </Modal>
  );
};

export default CatalogoInmuebles;



// WEBPACK FOOTER //
// ./src/catalogos/catalogoInmuebles.js